import { CheckmarkFilledIcon } from '@vizit/icons';
import { colors, cx } from '@vizit/theme';
import * as React from 'react';
import { CardLevelContext } from './card';

interface CardStatusIconProps extends React.HTMLAttributes<HTMLDivElement> {}

function CardStatusIcon(props: CardStatusIconProps) {
  const { className, ...rest } = props;

  const cardStatus = React.useContext(CardLevelContext);

  if (cardStatus === 'success') {
    return (
      <div
        className={cx(
          'absolute bottom-[21px] right-0 -translate-x-8 [@container(max-width:223px)]:top-[16px]',
          className,
        )}
        {...rest}
      >
        <CheckmarkFilledIcon size={20} color={colors.success['400']} aria-label="success" />
      </div>
    );
  }

  return null;
}

export { CardStatusIcon };
